import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const itemConditionsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.ITEM_CONDITION_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.ITEM_CONDITION_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.ITEM_CONDITION_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ITEM_CONDITIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ITEM_CONDITIONS_READ_SUCCESS:
      return {
        ...state,
        data, // Update the state with the fetched data
        error: false,
        loading: false,
      };
    case actions.ITEM_CONDITIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ITEM_CONDITION_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ITEM_CONDITION_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ITEM_CONDITION_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const itemConditionReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ITEM_CONDITION_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.ITEM_CONDITION_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.ITEM_CONDITION_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { itemConditionsReducer, itemConditionReducer };
